<template>

    <div class="ion-margin-top">
        <div class="">
            <ion-note>Limiti critici di cattura</ion-note>
            <div class="mei-formset-double-input-container">
                <div class="mei-formset-double-input">
                    <ion-note><small>Insetti striscianti</small></ion-note>
                    <br>
                    {{ captureLimitCrawlingLower }}<ion-icon class="muted" :icon="arrowDownOutline"></ion-icon> - {{ captureLimitCrawlingUpper }}<ion-icon class="muted" :icon="arrowUpOutline"></ion-icon>
                </div>
                <div class="mei-formset-double-input">
                    <ion-note><small>Roditori</small></ion-note>
                    <br>
                    {{ captureLimitRodentsLower }}<ion-icon class="muted" :icon="arrowDownOutline"></ion-icon> - {{ captureLimitRodentsUpper }}<ion-icon class="muted" :icon="arrowUpOutline"></ion-icon>
                </div>
            </div>
        </div>

        <div class="ion-margin-top-half">
            <ion-note>Catture</ion-note>
            <div class="mei-formset-double-input-container ion-margin-top-half">
                <div class="mei-formset-double-input">
                    <ion-input class="mei-input" tabindex="-1"
                               :value="crawlingAmount" @input="$emit('update:crawlingAmount', Number($event.target.value))"
                               label="Insetti striscianti" label-placement="stacked"
                               type="number"></ion-input>
                </div>
                <div class="mei-formset-double-input">
                    <ion-input class="mei-input" tabindex="-1"
                               :value="rodentsAmount" @input="$emit('update:rodentsAmount', Number($event.target.value))"
                               label="Roditori" label-placement="stacked"
                               type="number"></ion-input>
                </div>
            </div>
        </div>
    </div>
    <div class="mei-formset-accordion-field-group ion-margin-top">
        <ion-textarea class="mei-input mei-note-input" tabindex="-1"
                      :value="note" @input="$emit('update:note', $event.target.value)" label="Note"
                      label-placement="stacked"></ion-textarea>
    </div>
</template>

<script setup lang="ts">
import {IonInput, IonTextarea, IonNote, IonIcon} from "@ionic/vue";
import {arrowDownOutline, arrowUpOutline, arrowUpSharp} from "ionicons/icons";

defineProps({
    note: {
        type: String,
        required: true,
    },
    captureLimitCrawlingLower: {
        type: Number,
        required: true,
    },
    captureLimitCrawlingUpper: {
        type: Number,
        required: true,
    },
    captureLimitRodentsLower: {
        type: Number,
        required: true,
    },
    captureLimitRodentsUpper: {
        type: Number,
        required: true,
    },
    crawlingAmount: {
        type: Number,
        required: true,
    },
    rodentsAmount: {
        type: Number,
        required: true,
    }
});
defineEmits(['update:note', 'update:crawlingAmount', 'update:rodentsAmount']);
</script>

<style scoped>

</style>
